export const EntryFile = 'App.jsx';
export const EntryFileType = 'code/jsx';
